<template>
      <div class="menu-bar">
        <a target="_blank" href="http://www.cadal.edu.cn" >
          <img src="../assets/../assets/image/bg/logo.png"/>
        </a>
      <div>
        <ul class="top-menu">
          <li class="cur" @click="$router.push('/')">首页</li>
          <template v-if="showTabs">
              <li @click="goPath('report')">主旨报告</li>
              <li @click="goPath('cooperation','inter')">海外合作</li>
              <li @click="goPath('learning')">学术发展</li>
              <li @click="goPath('digitization')">数字化历程</li>
              <li @click="goPath('lookBack')">再回首</li>
          </template>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  data(){
     return{
        showTabs: true
     }
  },
  created(){
       this.showTabs = this.$route.path === '/'
  },
  methods: {
    goPath(path,subType) {
      this.$router.push({
        path: '/detail',
        query:{
          type: path,
          subType:subType
        }
      })
    }
  },
  watch: {
    '$route': function(route){
        this.showTabs = route.path !== '/detail'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/header.vue